import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-fe/sails_core';
import { WEBCHAT_TECHNICAL_ERROR } from 'Constant';
import { NAMESPACE } from './constants';
import { renderChatBubbles } from 'Container/Ui/helpers/renderWebchatBubbles';

import { createStructuredSelector } from 'reselect';
import sendWebchatMessageReducer from './reducer';
import sendMessageSaga from './sagas';
import {
    selectErrorCode,
    selectLoading,
} from './selector';

import { RootState } from './types';

function sendMessage (_state, _actions) {

    injectReducer(NAMESPACE, sendWebchatMessageReducer);
    injectSaga(NAMESPACE, sendMessageSaga);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState
         */
        getDerivedStateFromProps (newState, oldState) {

            if (newState.errorCode && (newState.errorCode !== oldState.errorCode)) {
                renderChatBubbles([WEBCHAT_TECHNICAL_ERROR], false);
            }
        },
    };

}

/**
 * mapStateToProps = We are mapping the given states to props mapDispatch
 */
const mapStateToProps = createStructuredSelector<RootState, {}>({
    errorCode: selectErrorCode(),
});

/**
 * mapDispatch = We are mapping the given action dispatch function to props Result.
 * You can use the states and dispatches as a prop in the main function
 */
const mapDispatch = {};

const SendMessage = connect(mapStateToProps, mapDispatch)(sendMessage);

export default SendMessage;
